<template>
    <!-- 考试详情部分 -->
    <div class="test-details container">
        <el-breadcrumb separator="/" style="margin-top:24px">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'userManagement' }">考试管理</el-breadcrumb-item>
            <el-breadcrumb-item>考试详情</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <el-card>
            <div slot="header" class="clearfix">
                <span>基本信息</span>
            </div>
            <div>
                <el-row :gutter="30">
                    <el-col :span="3" style="text-align:right">考试名称：</el-col>
                    <el-col :span="21">{{examInfo.examName}}</el-col>
                </el-row>
                <el-row :gutter="30" style="margin-top:30px">
                    <el-col :span="3" style="text-align:right;">考试类型：</el-col>
                    <el-col :span="21">{{examInfo.examType === 3 ? '模考' : examInfo.examType === 1 ? '公有' : '私有'}}考试</el-col>
                </el-row>
                <el-row :gutter="30" style="margin-top:30px">
                    <el-col :span="3" style="text-align:right;">考试描述：</el-col>
                    <el-col :span="21">{{examInfo.examSubscribe}}</el-col>
                </el-row>
            </div>
        </el-card>
        <br>
        <el-card>
            <div slot="header" class="clearfix">
                <span>考试设置</span>
            </div>
            <div>
                <el-row :gutter="30">
                    <el-col :span="4" style="text-align:right">考试时间：</el-col>
                    <el-col :span="20">{{examInfo.startTime}} ~ {{examInfo.endTime}}</el-col>
                </el-row>
                <el-row :gutter="30" style="margin-top:30px">
                    <el-col :span="4" style="text-align:right;">考试时长：</el-col>
                    <el-col :span="20">{{paperInfo.duration}}分钟</el-col>
                </el-row>
                <el-row :gutter="30" style="margin-top:30px">
                    <el-col :span="4" style="text-align:right;">及格分数：</el-col>
                    <el-col :span="20">{{paperInfo.passPoint}}分</el-col>
                </el-row>
                <el-row :gutter="30" style="margin-top:30px">
                    <el-col :span="4" style="text-align:right;">防作弊设置：</el-col>
                    <el-col :span="20">
                        <el-tag size="mini" effect="dark" type='warning' v-for="(item, i) in examInfo.antiCheatingArr" :key="i">
                            {{item}}
                        </el-tag>
                    </el-col>
                </el-row>
                <!-- <el-row :gutter="30" style="margin-top:30px">
					<el-col :span="4" style="text-align:right;">参加考试方式：</el-col>
					<el-col :span="20">XXX</el-col>
				</el-row> -->
                <!-- <el-row :gutter="30" style="margin-top:30px">
					<el-col :span="4" style="text-align:right;">显示成绩：</el-col>
					<el-col :span="20">XXX</el-col>
				</el-row> -->
            </div>
        </el-card>
        <br>
        <el-card>
            <div slot="header" class="clearfix">
                <span>试卷设置</span>
            </div>
            <div>
                <el-table class="test-details-tab" style="width: 100%" :border="true" :data="qTypeInfo" :header-cell-style="{
							textAlign: 'center',
							backgroundColor: '#f5f5f6'
						}">
                    <el-table-column prop="topic" label="题型"></el-table-column>
                    <el-table-column prop="number" label="题数"></el-table-column>
                    <el-table-column label="单题分">
                        <template slot-scope="scope">
                            <span>{{scope.row.score}}</span>分/题
                        </template>
                    </el-table-column>
                    <el-table-column label="总分">
                        <template slot-scope="scope">
                            <span>{{scope.row.total}}</span>分
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <br>
        <el-card>
            <div slot="header" class="clearfix">
                <span>考生设置</span>
            </div>
            <div>
                <el-row>
                    <el-col v-for="member in examStudents" :key="member.id" :span="12">
                        <el-col :span="6">{{member.nickName}}</el-col>
                        <el-col :span="18">{{member.username}}</el-col>
                    </el-col>
                </el-row>
                <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handlePageChange">
                </el-pagination>
            </div>
        </el-card>
        <br>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatQuestions, formatAnswerSheet } from '@/utils/exam';
import { getEtexamDetail } from '@/api/exam/etexam';
import { getEtexampaperDetail } from '@/api/exam/etexampaper';
import { getExamStudents } from '@/api/exam/etuserexamhistory';
export default {
    data () {
        return {
            page: {
                page: 1, // 当前页
                limit: 30, // 每页条目数
                total: 0,
                pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            },
            // 考试信息
            examInfo: {},
            // 试卷信息
            paperInfo: {},
            open: false,
            disable: true,
            isIndeterminate: false,
            checkAll: false,
            check: [],
            checkedGameId: [],
            examStudents: [],
            checkedList: [
                {
                    id: 1,
                    name: "张三",
                    phone: "135****6475"
                },
                {
                    id: 2,
                    name: "李四",
                    phone: "135****2475"
                },
                {
                    id: 3,
                    name: "王五",
                    phone: "135****2475"
                }
            ],
            value: [],
            data: [
                { key: 1, label: "张三" },
                { key: 2, label: "李四" },
                { key: 3, label: "王五" },
                { key: 4, label: "张三" },
                { key: 5, label: "李四" },
                { key: 6, label: "王五" }
            ]
        };
    },
    computed: {
        ...mapGetters(['questionTypeList']),
        oQuestions () {
            let oQuestions = {}
            let { content } = this.paperInfo
            this.questionTypeList.map(item => {
                oQuestions[item.id] = {
                    ...item,
                    list: [],
                    number: 0,
                    score: 0,
                    total: 0
                }
            })
            if (content) {
                content.map(item => {
                    let { number, total } = oQuestions[item.questionTypeId]
                    oQuestions[item.questionTypeId].list.push({
                        ...item
                    })
                    number += 1
                    total += item.questionPoint
                    oQuestions[item.questionTypeId].number = number
                    oQuestions[item.questionTypeId].total = total
                    oQuestions[item.questionTypeId].score = Number((total / number).toFixed(0))
                })
            }
            return oQuestions
        },
        qTypeInfo () {
            let arrQType = []
            Object.keys(this.oQuestions).forEach(key => {
                let { number, name, score, total } = this.oQuestions[key]
                if (number > 0) {
                    arrQType.push({
                        topic: name,
                        number,
                        score,
                        total
                    })
                }
            });
            return arrQType
        }
    },
    methods: {
        init () {
            this.getStudents()
            for (let i = 0; i < this.checkedList.length; i++) {
                this.checkedGameId.push(this.checkedList[i].id);
            }
            this.getExamInfo()
        },
        // 获取考试详情
        getExamInfo () {
            let { id } = this.$route.params
            getEtexamDetail(Number(id)).then(res => {
                this.examInfo = {
                    ...res,
                    antiCheatingArr: (() => {
                        let arr = res.antiCheating.split(',')
                        arr.map((item, i) => {
                            if (item === '1') {
                                arr[i] = '题目乱序'
                            } else if (item === '2') {
                                arr[i] = '选项乱序'
                            } else {
                                let arr2 = item.split(':')
                                arr[i] = `切屏 ${arr2[1]} 次强制交卷`
                            }
                        })
                        return arr
                    })()
                }
                this.getPaperInfo(res.examPaperId)
            })
        },
        // 获取试卷详情
        getPaperInfo (id) {
            getEtexampaperDetail(id).then(res => {
                let content = res.content ? formatQuestions(res.content) : []
                let answerSheet = formatAnswerSheet(res.answerSheet)
                this.paperInfo = {
                    ...res,
                    content,
                    answerSheet
                }
            })
        },
        handleCheckAllChange (val) {
            this.check = val ? this.checkedGameId : [];
            this.isIndeterminate = false;
            if (this.check.length > 0) {
                this.disable = false;
            } else {
                this.disable = true;
            }
        },
        handleCheckedCitiesChange (value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.checkedList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedList.length;
            if (this.check.length > 0) {
                this.disable = false;
            } else {
                this.disable = true;
            }
        },
        batchDelete () {
            this.$confirm("此操作将选中考生移除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => { }).catch(() => { });
        },
        getStudents () {
            let { id } = this.$route.params
            let { limit, page } = this.page
            this.examStudents = []
            getExamStudents({ limit, page, examId: id }).then(res => {
                let { list, totalCount } = res
                this.$set(this.page, 'total', totalCount)
                this.examStudents = list
            })
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'page', page)
            this.getStudents()
        }
    },
    created () {
        this.init();
    }
};
</script>

<style lang="less">
.test-details {
    .test-details-tab,
    .examinerTable {
        th,
        td {
            text-align: center;
        }
    }
    .examiner-list {
        padding: 10px 20px;
        .el-checkbox {
            background-color: #f0f0f0;
            padding: 10px;
            width: 100%;
            span:nth-of-type(2) {
                margin: 0 120px 0 80px;
            }
        }
    }
}
</style>

<style lang="less" scoped>
.test-details {
    min-height: 500px;
    .examiner {
        overflow: hidden;
        li {
            float: right;
            font-size: 14px;
            margin-left: 30px;
        }
    }
    .allCheck {
        position: absolute;
        top: -40px;
        left: 30px;
    }
}
</style>

